import apiAssegurouAuto from '../../services/apiAssegurouAuto';
import type { VehicleModelEntity } from '~/domain/Insurance/vehicleModelEntity';
import type { VehicleModelResponseDTO } from '~/dto/Insurance/vehicleModelResponseDTO';
import { vehicleModelResponseMapper } from '~/mappers/Insurance/vehicleModelResponseMapper';

export async function getVehicleModelsByYearManufacturerUseCase(
  manufacturerId: string,
  year: string
): Promise<VehicleModelEntity> {
  try {
    const response = await apiAssegurouAuto.get<VehicleModelResponseDTO>(
      `/auto/getModeloAno/1/${manufacturerId}/${year}`
    );
    return vehicleModelResponseMapper(response.data);
  } catch (error) {
    return {
      success: false,
      vehicleModels: [],
    };
  }
}
